import type { MainView } from '../core/domain/types';
import { useUiStore } from '../store/uiStore';

const items: Array<{ id: MainView; label: string; icon: string }> = [
  { id: 'farm', label: '农场', icon: '🌱' },
  { id: 'home', label: '小屋', icon: '🏡' },
  { id: 'wardrobe', label: '换装', icon: '👗' },
  { id: 'shop', label: '商店', icon: '🛒' },
  { id: 'quests', label: '任务', icon: '📋' },
];

export function Navigation() {
  const view = useUiStore((state) => state.view);
  const setView = useUiStore((state) => state.setView);
  return (
    <nav className="navigation" aria-label="主导航">
      {items.map((item) => (
        <button
          key={item.id}
          data-tutorial-target={`nav-${item.id}`}
          className={view === item.id ? 'active' : ''}
          onClick={() => setView(item.id)}
        >
          <span>{item.icon}</span>
          {item.label}
        </button>
      ))}
    </nav>
  );
}
